"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var Select_1 = __importDefault(require("@material-ui/core/Select"));
var MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
var Utils = __importStar(require("./utils"));
function Select(props) {
    var id = props.id, name = props.name, data = props.data, promise = props.promise, disabled = props.disabled, shouldReturnOnlyId = props.shouldReturnOnlyId, rest = __rest(props, ["id", "name", "data", "promise", "disabled", "shouldReturnOnlyId"]);
    var _a = react_1.useState(props.options || []), options = _a[0], setOptions = _a[1];
    var strName = name.toString();
    var _b = react_1.useState(Utils.propValueToDefault(name, options, data)), value = _b[0], setValue = _b[1];
    react_1.useEffect(function () {
        setValue(Utils.propValueToDefault(name, options, data));
    }, [strName, data, options]);
    react_1.useEffect(function () {
        setOptions(props.options || []);
    }, [props.options]);
    if (promise) {
        promise.then(function (x) {
            setOptions(x);
            setValue(Utils.propValueToDefault(name, options, data));
        });
    }
    var onChange = function (event) {
        var selectedValue = event.target.value;
        var newOption = options.filter(function (option) {
            return Utils.isUOptionSet(option)
                ? option.uuid === selectedValue
                : option.id === selectedValue;
        })[0];
        var newValue = Utils.isUOptionSet(newOption)
            ? newOption.uuid
            : newOption.id;
        props.onChange({
            name: strName,
            value: shouldReturnOnlyId === true ? newValue : newOption
        });
        setValue(newValue);
    };
    return (react_1["default"].createElement(Select_1["default"], __assign({ id: id ? id : strName, name: strName }, rest, { onChange: onChange, value: value, fullWidth: true, disabled: disabled }), options.map(function (option, k) { return (react_1["default"].createElement(MenuItem_1["default"], { key: k, value: Utils.isUOptionSet(option) ? option.uuid : option.id }, option.name)); })));
}
exports["default"] = Select;
